import { useAllClasses } from '../../../selectors/global';
import { TClassSummary } from '../../../../../types/utilityTypes';
import { IRioSelectProps } from '../../../../components/presentational/select/types';
import { RioSelect } from '../../../../components/presentational/select/Select';
import { ClassOption, IClassOptionProps } from './ClassOption';
import { DEFAULT_CLASS_VIEW_OPTIONS } from './lib';
import { TClassSelectViewOptions } from './types';

export interface IClassSelectProps<
  Value,
  IsMulti extends boolean = false,
  IsClearable extends boolean = false
> extends Omit<IRioSelectProps<TClassSummary, Value, IsMulti, IsClearable>, 'options'> {
  viewOptions?: TClassSelectViewOptions;
  optionProps?: Partial<IClassOptionProps>;
}

export const ClassSelect = <Value, IsMulti extends boolean = false, IsClearable extends boolean = false>({
  viewOptions,
  optionProps,
  ...props
}: IClassSelectProps<Value, IsMulti, IsClearable>) => {
  const normalizedViewOptions = Object.assign({}, DEFAULT_CLASS_VIEW_OPTIONS, viewOptions);
  const allClasses = useAllClasses();

  return (
    <RioSelect
      {...props}
      options={allClasses}
      formatOptionLabel={(cls, { context }) => {
        return <ClassOption cls={cls} viewOptions={normalizedViewOptions} {...optionProps} context={context} />;
      }}
    />
  );
};
